import TenantLogo from '@/utils/tenantLogo';
import { useTranslation } from '@/utils/useTranslation';
import { useGlobalContext } from '../GlobalProvider';
import { Box, Icon, Paragraph } from '@alto-avios/alto-ui';

export const Hero = () => {
  const { t } = useTranslation('marketing');
  const { programmeId } = useGlobalContext();

  const benefits = t<Array<string>>('benefits', {
    returnObjects: true,
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="xl"
      paddingX="lg"
      paddingY="xl"
    >
      <TenantLogo programmeId={programmeId} />
      <Box display="flex" flexDirection="column" gap="2xs" alignItems="start">
        {benefits.map(benefit => (
          <Box key={benefit} display="flex" alignItems="center" gap="2xs">
            <Icon iconName="check" iconSize="0.75x" color="accentPrimary" />
            <Paragraph key={benefit} size="xs">
              {benefit}
            </Paragraph>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
